module.exports = {
      id: "tamilnadu-usage",
      viewBox: "0 0 857.199 1020.664",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#tamilnadu",
      toString: function () {
        return this.url;
      }
    }